module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.e49d52e7.ttf";